export const topics = [
  {
    id: "summer-music-festival-lineup",
    title: "夏日音乐节阵容公布，评论区从下午吵到凌晨",
    summary:
      "今年暑期档音乐节的完整阵容一放出来，社交平台瞬间被刷屏。有人为压轴乐队欢呼，也有人替没排上场的独立音乐人抱不平，讨论热度一路走高。",
    category: "entertainment",
    categoryName: "娱乐八卦",
    heat: 986000,
    views: 5428000,
    comments: 18742,
    time: "12 分钟前",
    author: "围观编辑部",
    tags: ["音乐节", "阵容", "现场"],
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20music%20festival%20stage%20with%20warm%20amber%20and%20tomato%20red%20stage%20lights%2C%20glowing%20bokeh%2C%20crowd%20silhouettes%2C%20cinematic%20editorial%20photography%2C%20soft%20warm%20tones%2C%20no%20text&width=800&height=600&seq=gossip-topic-01&orientation=landscape",
  },
  {
    id: "new-drama-reputation-reversal",
    title: "新剧开播三天口碑反转，观众到底在吵什么",
    summary:
      "开分与追更口碑出现明显分叉，前两集被吐槽节奏慢，第四集之后又被夸封神。我们把评论区高频出现的几个观点整理了一遍。",
    category: "screen",
    categoryName: "影视综",
    heat: 872000,
    views: 4130000,
    comments: 15208,
    time: "38 分钟前",
    author: "剧集观察员",
    tags: ["新剧", "口碑", "追更"],
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20vintage%20cinema%20interior%20with%20deep%20red%20velvet%20seats%2C%20warm%20spotlight%20beams%2C%20film%20reel%20texture%2C%20elegant%20moody%20lighting%2C%20editorial%20photography%2C%20warm%20palette&width=800&height=600&seq=gossip-topic-02&orientation=landscape",
  },
  {
    id: "retro-film-aesthetic-return",
    title: "复古胶片风集体回潮，年轻人为什么开始怀旧",
    summary:
      "从相机销量到穿搭话题，胶片质感重新成为社交平台的流量密码。有人说是审美疲劳后的反弹，也有人觉得是大家想慢下来。",
    category: "lifestyle",
    categoryName: "生活方式",
    heat: 693000,
    views: 2870000,
    comments: 9640,
    time: "1 小时前",
    author: "生活方式组",
    tags: ["胶片", "复古", "审美"],
    image:
      "https://readdy.ai/api/search-image?query=Flat%20lay%20of%20retro%20film%20camera%2C%20vintage%20photo%20prints%20and%20warm%20film%20grain%20texture%20on%20a%20cream%20paper%20background%2C%20golden%20afternoon%20light%2C%20editorial%20still%20life%2C%20warm%20tones&width=800&height=600&seq=gossip-topic-03&orientation=landscape",
  },
  {
    id: "late-night-food-economy",
    title: "深夜食堂话题刷屏，宵夜经济又被带火了",
    summary:
      "一条“凌晨两点还开着的店”的帖子引来上万人补充分享，各地网友把自己城市的深夜宝藏小店翻了个底朝天。",
    category: "lifestyle",
    categoryName: "生活方式",
    heat: 615000,
    views: 2340000,
    comments: 11872,
    time: "2 小时前",
    author: "城市味觉",
    tags: ["宵夜", "深夜食堂", "城市"],
    image:
      "https://readdy.ai/api/search-image?query=Late%20night%20street%20food%20stall%20with%20glowing%20warm%20lanterns%20and%20rising%20steam%2C%20cozy%20night%20atmosphere%2C%20amber%20highlights%2C%20cinematic%20editorial%20photography%2C%20warm%20color%20grading&width=800&height=600&seq=gossip-topic-04&orientation=landscape",
  },
  {
    id: "variety-editing-controversy",
    title: "综艺剪辑争议持续发酵，观众直呼看不懂了",
    summary:
      "同一段素材被剪出两种叙事走向，嘉宾表情与字幕引导引发大量讨论，节目组暂未回应，话题仍在持续升温。",
    category: "screen",
    categoryName: "影视综",
    heat: 578000,
    views: 1980000,
    comments: 8241,
    time: "3 小时前",
    author: "综艺前线",
    tags: ["综艺", "剪辑", "争议"],
    image:
      "https://readdy.ai/api/search-image?query=Modern%20television%20studio%20with%20soft%20studio%20lights%20and%20warm%20amber%20practical%20lamps%2C%20abstract%20geometric%20backdrop%2C%20cinematic%20wide%20shot%2C%20warm%20neutral%20palette%2C%20editorial&width=800&height=600&seq=gossip-topic-05&orientation=landscape",
  },
  {
    id: "city-walk-weekend-route",
    title: "城市漫游路线爆火，周末打卡有了新玩法",
    summary:
      "不走景点、只走街巷的“城市漫游”成为周末新选择。我们整理了三条不走回头路的路线，以及每个路段的休息点。",
    category: "lifestyle",
    categoryName: "生活方式",
    heat: 462000,
    views: 1620000,
    comments: 6183,
    time: "5 小时前",
    author: "周末漫游",
    tags: ["城市漫游", "周末", "路线"],
    image:
      "https://readdy.ai/api/search-image?query=Stylized%20city%20street%20on%20a%20weekend%20afternoon%20with%20warm%20sunlight%2C%20cobblestone%20path%20and%20cozy%20cafes%2C%20soft%20golden%20tones%2C%20travel%20editorial%20photography%2C%20no%20text&width=800&height=600&seq=gossip-topic-06&orientation=landscape",
  },
  {
    id: "ai-virtual-streamer-debate",
    title: "虚拟主播集体上线，网友的态度分成两派",
    summary:
      "虚拟形象直播数量明显增加，有人认为新颖有陪伴感，也有人担心内容同质化。我们把两种声音的代表观点都放了出来。",
    category: "tech",
    categoryName: "科技新鲜事",
    heat: 421000,
    views: 1450000,
    comments: 7392,
    time: "6 小时前",
    author: "科技新鲜报",
    tags: ["虚拟人", "直播", "AI"],
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20glowing%20digital%20human%20silhouette%20made%20of%20warm%20amber%20and%20coral%20light%20particles%2C%20futuristic%20technology%20concept%2C%20dark%20warm%20background%2C%20cinematic%20editorial%20render&width=800&height=600&seq=gossip-topic-07&orientation=landscape",
  },
  {
    id: "veteran-band-tour-sold-out",
    title: "老牌乐队宣布巡演，门票十分钟售罄",
    summary:
      "沉寂数年后宣布回归巡演，开票十分钟即告售罄，二手平台价格被迅速炒高，官方提示谨防非正规渠道交易。",
    category: "entertainment",
    categoryName: "娱乐八卦",
    heat: 397000,
    views: 1280000,
    comments: 5941,
    time: "8 小时前",
    author: "现场记录员",
    tags: ["巡演", "乐队", "门票"],
    image:
      "https://readdy.ai/api/search-image?query=Live%20band%20performing%20on%20stage%20with%20warm%20amber%20spotlights%20and%20hazy%20atmosphere%2C%20silhouette%20of%20instruments%2C%20cinematic%20concert%20editorial%20photography%2C%20warm%20tones&width=800&height=600&seq=gossip-topic-08&orientation=landscape",
  },
  {
    id: "outdoor-camping-checklist",
    title: "户外露营装备清单引发全民补充，新手先看这份",
    summary:
      "一份入门级露营清单被顶上热搜，评论区变成了大型经验分享现场。我们按预算分档，把重复提交最多的装备整理成表格。",
    category: "lifestyle",
    categoryName: "生活方式",
    heat: 338000,
    views: 1090000,
    comments: 4870,
    time: "10 小时前",
    author: "户外手册",
    tags: ["露营", "装备", "新手"],
    image:
      "https://readdy.ai/api/search-image?query=Cozy%20camping%20gear%20flat%20lay%20with%20canvas%20tent%2C%20lantern%20and%20wooden%20crate%20on%20warm%20earth%20tones%2C%20soft%20natural%20light%2C%20outdoor%20lifestyle%20editorial%2C%20cream%20background&width=800&height=600&seq=gossip-topic-09&orientation=landscape",
  },
  {
    id: "trend-archive-minimal",
    title: "年度趋势盘点：这一年被讨论最多的十个词",
    summary:
      "我们把过去一年站内热度曲线上涨最明显的十个关键词做了复盘，每一个都附上了它爆发的节点与关键讨论。",
    category: "society",
    categoryName: "社会热点",
    heat: 286000,
    views: 940000,
    comments: 3521,
    time: "昨天",
    author: "数据围观",
    tags: ["盘点", "趋势", "年度"],
    image:
      "https://readdy.ai/api/search-image?query=Minimal%20editorial%20still%20life%20of%20stacked%20warm%20cream%20paper%20cards%20with%20amber%20accents%20on%20a%20soft%20neutral%20surface%2C%20data%20archive%20concept%2C%20warm%20tones%2C%20soft%20shadows&width=800&height=600&seq=gossip-topic-10&orientation=landscape",
  },
];